import React from 'react';
import UserAvatar from 'react-user-avatar';
import './ProfileImage.css';

/**
* @desc Candidate Initials in candidate profile section
* @param props
* @return Candidate Initials 
*/
const Initials = (props) => {
  const initialColor=['#E0E9F2', '#C9EDE6', '#C4CAD0', '#F4ADAE', '#E9D7D8', '#EAC0CE'];

	return ( <div className="profile-image-wrapper">
              <UserAvatar 
                className="UserAvatar-light" 
                name={props.initials} 
                colors={initialColor}
              /> 
              {(props.tooltipText && props.tooltipText !== null && props.tooltipText!=="") ?
                <span className="profile-image-tooltip">
                  {props.tooltipText}
                </span>
              :null}
            </div>);
}

const Photo = (props) => {
return (  <div className={props.className + " profile-image-wrapper"}>
            <img src={props.imageUrl} />
            {(props.tooltipText && props.tooltipText !== null && props.tooltipText!=="") ?
              <span className="profile-image-tooltip">
                {props.tooltipText}
              </span>
            :null}
          </div> );
}

function ProfilePhoto(props) {
  if (props.imageUrl && props.imageUrl !== null && props.imageUrl !== "") {
    return <Photo 
              className={props.className} 
              imageUrl={props.imageUrl} 
              tooltipText={props.tooltipText} 
            />;
  }
  return <Initials 
            initials={props.initials} 
            tooltipText={props.tooltipText}
          />
}

/**
* @desc ProfileImage in candidate profile section
* @param props
* @return ProfileImage
*/
const ProfileImage = (props) => {
  return (
    <div>
      <ProfilePhoto 
        className={props.className} 
        initials={props.initials} 
        imageUrl={props.imageUrl} 
        tooltipText={props.tooltipText} 
      />
    </div>
  );
}

export default ProfileImage;


// WEBPACK FOOTER //
// ./src/components/UI/ProfileImage/ProfileImage.js